import { useSyncExternalStore } from 'react';

// next-themes puts the `dark` class on <html>; watching the class follows the
// toggle as well as the system setting.
function subscribe(onChange: () => void) {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class']
  });
  return () => observer.disconnect();
}

/**
 * Whether the site is showing its dark theme. The server snapshot is `false`,
 * so the first client render matches the server markup and the real value
 * lands in the commit after hydration.
 */
export function useIsDarkTheme() {
  return useSyncExternalStore(subscribe, _temp, _temp2);
}
function _temp2() {
  return false;
}
function _temp() {
  return document.documentElement.classList.contains("dark");
}